@if (filteredItems$ | async; as filteredItems) {
  <div class="list">
    <div class="mdc-layout-grid" matSort (matSortChange)="sortData($event)">
      <div class="header mdc-layout-grid__inner full-width">
        @for (column of columns; track column) {
          <div
            [mat-sort-header]="column.key"
            [ngClass]="[
              'mdc-layout-grid__cell',
              'mdc-layout-grid__cell--span-' + desktopColumnSize + '-desktop',
              'mdc-layout-grid__cell--span-' + mobileColumnSize + '-phone',
            ]"
          >
            {{ column.label | i18nextCap }}
          </div>
        }
      </div>
      <div
        class="body"
        infiniteScroll
        [infiniteScrollDistance]="0"
        [infiniteScrollThrottle]="50"
        [scrollWindow]="false"
        (scrolled)="onLoadMore()"
      >
        @for (item of filteredItems; track item) {
          <div
            [ngClass]="[
              'line mdc-layout-grid__inner',
              item.background ? item.background : 'grey-50',
            ]"
          >
            @for (column of columns; track column; let i = $index) {
              <div
                [class.align-center]="i"
                [ngClass]="[
                  'mdc-layout-grid__cell',
                  'mdc-layout-grid__cell--span-' +
                    desktopColumnSize +
                    '-desktop',
                  'mdc-layout-grid__cell--span-' + mobileColumnSize + '-phone',
                ]"
                (click)="onOpen(item.id)"
              >
                @if (!i && item.rowType) {
                  @switch (item.rowType.value) {
                    @case (ActivityType.CALL) {
                      <mat-icon aria-hidden="false" aria-label="call"
                        >call</mat-icon
                      >
                    }
                    @case (ActivityType.EMAIL) {
                      <mat-icon aria-hidden="false" aria-label="email"
                        >email</mat-icon
                      >
                    }
                    @case (ActivityType.REMINDER) {
                      <mat-icon aria-hidden="false" aria-label="REMINDER"
                        >timelapse</mat-icon
                      >
                    }
                    @case (ActivityType.MEETING) {
                      <mat-icon aria-hidden="false" aria-label="meeting"
                        >people</mat-icon
                      >
                    }
                    @case (ActivityType.TASK) {
                      <mat-icon aria-hidden="false" aria-label="task"
                        >assignment</mat-icon
                      >
                    }
                  }
                }
                @switch (column.type) {
                  @case (columnType.Label) {
                    <label
                      [ngClass]="['mat-label', item.columns[column.key].color]"
                    >
                      {{
                        'forms:' + item.columns[column.key].value | i18nextCap
                      }}
                    </label>
                  }
                  @case (columnType.Text) {
                    <span [class.align-center]="item.rowType">{{
                      item.columns[column.key].value
                    }}</span>
                  }
                  @case (columnType.Enum) {
                    <span>{{
                      item.columns[column.key].value | i18nextCap
                    }}</span>
                  }
                  @case (columnType.Number) {
                    {{ item.columns[column.key].value }}
                  }
                  @case (columnType.Price) {
                    @if (item.columns[column.key].value === 0) {
                      -
                    }
                    @if (item.columns[column.key].value !== 0) {
                      {{ item.columns[column.key].value }} €
                    }
                  }
                  @case (columnType.Date) {
                    @if (item.columns[column.key].value !== 0) {
                      {{ item.columns[column.key].value | date: 'd MMMM y' }}
                    }
                  }
                  @case (columnType.User) {
                    @if (item.columns[column.key].value !== '-') {
                      <span
                        aria-hidden="false"
                        aria-label="request-ticket"
                        class="user-icon"
                      >
                        <img src="assets/svg/fo-user.svg" alt="User Icon" />
                      </span>
                    }
                    <span>{{
                      item.columns[column.key].value | titlecase
                    }}</span>
                  }
                  @case (columnType.Identifier) {
                    @if (item.columns[column.key].warranty !== 'false') {
                      <mat-icon aria-hidden="false" aria-label="request-ticket"
                        >star</mat-icon
                      >
                    }
                    <span>{{
                      item.columns[column.key].value | titlecase
                    }}</span>
                  }
                  @case (columnType.Company) {
                    <mat-icon aria-hidden="false" aria-label="request-ticket"
                      >home_repair_service</mat-icon
                    >
                    {{ item.columns[column.key].value | titlecase }}
                  }
                  @case (columnType.Request) {
                    <mat-icon aria-hidden="false" aria-label="request-ticket"
                      >local_shipping</mat-icon
                    >
                    {{ item.columns[column.key].value | titlecase }}
                  }
                  @case (columnType.Array) {
                    @for (
                      label of item.columns[column.key].value;
                      track label
                    ) {
                      <label
                        class="mat-label"
                        [ngClass]="[label.color ? label.color : 'grey-100']"
                      >
                        {{ label.label | i18nextCap }}
                      </label>
                    }
                  }
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}
